import { MetingInputDto, Relatie } from '@/lib/types/relatie';

export function sanitizeMetingen(relatie: Relatie) {
  const metingen = relatie.metingen?.filter(Boolean).map(group => {
    const sanitizeRows = (rows: MetingInputDto[] | undefined, sodium = false) =>
      rows
        ?.slice(0, group.aantalMetingenPerJaar > 0 ? group.aantalMetingenPerJaar : undefined)
        ?.map(
          (row, index) =>
            row && {
              ...row,
              periode: index + 1,
              datum: row.geenMeting ? undefined : group.nH4Metingen?.[index]?.datum,
            }
        )
        .filter(row => row && ((row.datum != null && row.gehalte != null) || row.geenMeting || (sodium && row.geenNatrium)));

    return {
      ...group,
      nH4Metingen: sanitizeRows(group.nH4Metingen) ?? [],
      nO3Metingen: sanitizeRows(group.nO3Metingen) ?? [],
      pMetingen: sanitizeRows(group.pMetingen),
      naMetingen: sanitizeRows(group.naMetingen, Number(relatie.registratiejaar) === 2026),
    };
  });

  return metingen ? { metingen } : {};
}
